module.exports = __webpack_public_path__ + "static/img/Joel_Selwood_mobile.a910b3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joel_Selwood_mobile.jpg
// module id = zvRa
// module chunks = 0